import { render, staticRenderFns } from "./DadosCaptacao.vue?vue&type=template&id=2192e168&scoped=true&"
import script from "./DadosCaptacao.vue?vue&type=script&lang=js&"
export * from "./DadosCaptacao.vue?vue&type=script&lang=js&"
import style0 from "./DadosCaptacao.vue?vue&type=style&index=0&id=2192e168&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2192e168",
  null
  
)

export default component.exports